'use strict';
var _ = require('lodash');

var regex = {
		phone: /^\+?[0-9x\ \-\.\(\)]{11,15}$/,
		postal: {
			us: /^\d{5}(-\d{4})?$/,
			au: /^\d{4}$/,
			ca: /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$/,
			gb: /^(GIR ?0AA|[A-PR-UWYZ]([0-9]{1,2}|([A-HK-Y][0-9]([0-9ABEHMNPRV-Y])?)|[0-9][A-HJKPS-UW]) ?[0-9][ABD-HJLNP-UW-Z]{2})$/,
			je: /^JE\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
			gg: /^GY\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
			im: /^IM\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
			de: /^\d{5}$/,
			jp: /^\d{3}-\d{4}$/,
			fr: /^\d{2}[ ]?\d{3}$/,
			it: /^\d{5}$/,
			ch: /^\d{4}$/,
			at: /^\d{4}$/,
			es: /^\d{5}$/,
			nl: /^\d{4}[ ]?[A-Z]{2}$/,
			be: /^\d{4}$/,
			dk: /^\d{4}$/,
			se: /^\d{3}[ ]?\d{2}$/,
			no: /^\d{4}$/,
			br: /^\d{5}[\-]?\d{3}$/,
			pt: /^\d{4}([\-]\d{3})?$/,
			fi: /^\d{5}$/,
			ax: /^22\d{3}$/,
			kr: /^\d{3}[\-]\d{3}$/,
			cn: /^\d{6}$/,
			tw: /^\d{3}(\d{2})?$/,
			sg: /^\d{6}$/,
			dz: /^\d{5}$/,
			ad: /^AD\d{3}$/,
			ar: /^([A-HJ-NP-Z])?\d{4}([A-Z]{3})?$/,
			am: /^(37)?\d{4}$/,
			az: /^\d{4}$/,
			bh: /^((1[0-2]|[2-9])\d{2})?$/,
			bd: /^\d{4}$/,
			bb: /^(BB\d{5})?$/,
			by: /^\d{6}$/,
			bm: /^[A-Z]{2}[ ]?[A-Z0-9]{2}$/,
			ba: /^\d{5}$/,
			io: /^BBND 1ZZ$/,
			bn: /^[A-Z]{2}[ ]?\d{4}$/,
			bg: /^\d{4}$/,
			kh: /^\d{5}$/,
			cv: /^\d{4}$/,
			cl: /^\d{7}$/,
			cr: /^\d{4,5}|\d{3}-\d{4}$/,
			hr: /^\d{5}$/,
			cy: /^\d{4}$/,
			cz: /^\d{3}[ ]?\d{2}$/,
			do: /^\d{5}$/,
			ec: /^([A-Z]\d{4}[A-Z]|(?:[A-Z]{2})?\d{6})?$/,
			eg: /^\d{5}$/,
			ee: /^\d{5}$/,
			fo: /^\d{3}$/,
			ge: /^\d{4}$/,
			gr: /^\d{3}[ ]?\d{2}$/,
			gl: /^39\d{2}$/,
			gt: /^\d{5}$/,
			ht: /^\d{4}$/,
			hn: /^(?:\d{5})?$/,
			hu: /^\d{4}$/,
			is: /^\d{3}$/,
			in: /^\d{6}$/,
			id: /^\d{5}$/,
			il: /^\d{5}$/,
			jo: /^\d{5}$/,
			kz: /^\d{6}$/,
			ke: /^\d{5}$/,
			kw: /^\d{5}$/,
			la: /^\d{5}$/,
			lv: /^\d{4}$/,
			lb: /^(\d{4}([ ]?\d{4})?)?$/,
			li: /^(948[5-9])|(949[0-7])$/,
			lt: /^\d{5}$/,
			lu: /^\d{4}$/,
			mk: /^\d{4}$/,
			my: /^\d{5}$/,
			mv: /^\d{5}$/,
			mt: /^[A-Z]{3}[ ]?\d{2,4}$/,
			mu: /^(\d{3}[A-Z]{2}\d{3})?$/,
			mx: /^\d{5}$/,
			md: /^\d{4}$/,
			mc: /^980\d{2}$/,
			ma: /^\d{5}$/,
			np: /^\d{5}$/,
			nz: /^\d{4}$/,
			ni: /^((\d{4}-)?\d{3}-\d{3}(-\d{1})?)?$/,
			ng: /^(\d{6})?$/,
			om: /^(PC )?\d{3}$/,
			pk: /^\d{5}$/,
			py: /^\d{4}$/,
			ph: /^\d{4}$/,
			pl: /^\d{2}-\d{3}$/,
			pr: /^00[679]\d{2}([ \-]\d{4})?$/,
			ro: /^\d{6}$/,
			ru: /^\d{6}$/,
			sm: /^4789\d$/,
			sa: /^\d{5}$/,
			sn: /^\d{5}$/,
			sk: /^\d{3}[ ]?\d{2}$/,
			si: /^\d{4}$/,
			za: /^\d{4}$/,
			lk: /^\d{5}$/,
			tj: /^\d{6}$/,
			th: /^\d{5}$/,
			tn: /^\d{4}$/,
			tr: /^\d{5}$/,
			tm: /^\d{6}$/,
			ua: /^\d{5}$/,
			uy: /^\d{5}$/,
			uz: /^\d{6}$/,
			va: /^00120$/,
			ve: /^\d{4}$/,
			zm: /^\d{5}$/,
			as: /^96799$/,
			cc: /^6799$/,
			ck: /^\d{4}$/,
			rs: /^\d{6}$/,
			me: /^8\d{4}$/,
			cs: /^\d{5}$/,
			yu: /^\d{5}$/,
			cx: /^6798$/,
			et: /^\d{4}$/,
			fk: /^FIQQ 1ZZ$/,
			nf: /^2899$/,
			fm: /^(9694[1-4])([ \-]\d{4})?$/,
			gf: /^9[78]3\d{2}$/,
			gn: /^\d{3}$/,
			gp: /^9[78][01]\d{2}$/,
			gs: /^SIQQ 1ZZ$/,
			gu: /^969[123]\d([ \-]\d{4})?$/,
			gw: /^\d{4}$/,
			hm: /^\d{4}$/,
			iq: /^\d{5}$/,
			kg: /^\d{6}$/,
			lr: /^\d{4}$/,
			ls: /^\d{3}$/,
			mg: /^\d{3}$/,
			mh: /^969[67]\d([ \-]\d{4})?$/,
			mn: /^\d{6}$/,
			mp: /^9695[012]([ \-]\d{4})?$/,
			mq: /^9[78]2\d{2}$/,
			nc: /^988\d{2}$/,
			ne: /^\d{4}$/,
			vi: /^008(([0-4]\d)|(5[01]))([ \-]\d{4})?$/,
			pf: /^987\d{2}$/,
			pg: /^\d{3}$/,
			pm: /^9[78]5\d{2}$/,
			pn: /^PCRN 1ZZ$/,
			pw: /^96940$/,
			re: /^9[78]4\d{2}$/,
			sh: /^(ASCN|STHL) 1ZZ$/,
			sj: /^\d{4}$/,
			so: /^\d{5}$/,
			sz: /^[HLMS]\d{3}$/,
			tc: /^TKCA 1ZZ$/,
			wf: /^986\d{2}$/,
			xk: /^\d{5}$/,
			yt: /^976\d{2}$/,
			other: /^[A-Za-z0-9\s\-]{2,10}$/
		},
		email: /^[\w.%+\-]{1,64}@[\w\-]+(\.[\w\-]{2,20}){1,6}$/,
		notCC: /^(?!(([0-9 -]){13,19})).*$/,
		date: /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/[0-9]{4}$/,
		alphanumeric: /^[A-Za-z0-9\s]+$/,
		vipmecode: /^(([2-3][\d]{7})|(6[1-2][\d]{8})|(8[1-4][\d]{10}))$/,
		eorinumberni: /^[A-Za-z0-9]{1,17}$/
	};

// global form validator settings
var settings = {
    errorClass: 'error',
    errorElement: 'span',
    onkeyup: false,
    onfocusout: function (element) {
        if (!this.checkable(element)) {
            this.element(element);
        }
    }
};

/**
 * @function
 * @description Validates a given phone number against the phone regex
 * @param {String} value The phone number which will be validated
 * @param {String} el The input field
 */
var validatePhone = function (value, el) {
	var rgx = regex.phone;
	var isOptional = this.optional(el);
	var trimmedValue = $.trim(value);

	// Do not validate if it's an optional field and the value is empty
	if (isOptional && trimmedValue === '') {
		return true;
	} else {
		return rgx.test(trimmedValue);
	}
};

/**
 * @function
 * @description Validates a given date against the regex to be of format DD/MM/YYYY
 * @param {String} value The date which will be validated
 * @param {String} el The input field
 */
var validateDateWithFormat = function (value, el) {
	var isOptional = this.optional(el);
	var trimmedValue = $.trim(value);

	if (isOptional && trimmedValue === '') {
		return true;
	} else {
		return regex.date.test(value);
	}
};
/**
 * @function
 * @description Validates a given email
 * @param {String} value The email which will be validated
 * @param {String} el The input field
 */
var validateEmail = function (value, el) {
	var isOptional = this.optional(el);
	var isValid = regex.email.test($.trim(value));
	return isOptional || isValid;
};

var validatePostcode = function (value, el) {
    var isOptional = this.optional(el);
    var countryEl = $(el).parents('form').find('select[name$="country"]');
    var selectedCountryEl = $(countryEl).val().toLowerCase();
    var regexCurrent = regex.postal[selectedCountryEl];
    if (!regexCurrent) {
        regexCurrent = regex.postal.other;
    }
    var isValid = regexCurrent.test($.trim(value));

    return isOptional || isValid;
};

var validateAlphanumeric = function (value) {
	return regex.alphanumeric.test(value);
};

var validateEORINumber = function (value) {
	return regex.eorinumberni.test(value);
};

/**
 * @function
 * @description Validates that a credit card owner is not a Credit card number
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateOwner = function (value) {
	var isValid = regex.notCC.test($.trim(value));
	return isValid;
};

var validateVipmeCode = function (value, el) {
	var isOptional = this.optional(el);
	var trimmedValue = $.trim(value);
	if (isOptional && trimmedValue === '') {
		return true;
	} else {
		return regex.vipmecode.test(value);
	}
};

//global form validator settings
$.validator.setDefaults({
	errorClass: 'error',
	errorElement: 'span',
	onkeyup: false,
	errorPlacement: function (error, element) {
		error.addClass('error-msg');
		$(element).parents('.form-row').append(error);
	},
	highlight: function (el) {
		var $selectWrp = $(el).parent();
		if ($selectWrp.hasClass('selector')) {
			$selectWrp.addClass('error');
		} else {
			$(el).removeClass('valid').addClass('error');
		}
	},
	unhighlight: function (el) {
		var $selectWrp = $(el).parent();
		if ($selectWrp.hasClass('selector')) {
			$selectWrp.removeClass('error');
		} else {
			$(el).removeClass('error').addClass('valid');
		}
	}
});

/**
 * Add phone validation method to jQuery validation plugin.
 * Text fields must have 'phone' css class to be validated as phone
 */
$.validator.addMethod('phone', validatePhone, Resources.INVALID_PHONE);

/**
 * Add mobile phone validation method to jQuery validation plugin.
 * Text fields must have 'mobilephone' css class to be validated as phone
 */
$.validator.addMethod('mobilephone', validatePhone, Resources.INVALID_PHONE);

/**
 * Add email validation method to jQuery validation plugin.
 * Text fields must have 'email' css class to be validated as email
 */
$.validator.addMethod('email', validateEmail, Resources.INVALID_EMAIL);

$.validator.addMethod('alphanumeric', validateAlphanumeric, Resources.SPECIAL_CHARACTERS_ERROR);

$.validator.addMethod('postcode', validatePostcode, Resources.POSTCODE_FORMAT);

$.validator.addMethod('eorinumberni', validateEORINumber, Resources.INVALID_EORI_NUMBER);

$.validator.addMethod('date-required', validateDateWithFormat, Resources.SELECT_VALID_DATE);

$.validator.addMethod('vipmecode', validateVipmeCode, Resources.VIPME_CODE);

$.validator.addMethod('username', validateEmail, Resources.INVALID_USERNAME);

/**
 * Add CCOwner validation method to jQuery validation plugin.
 * Text fields must have 'owner' css class to be validated as not a credit card
 */
$.validator.addMethod('owner', validateOwner, Resources.INVALID_OWNER);

/**
 * Add gift cert amount validation method to jQuery validation plugin.
 * Text fields must have 'gift-cert-amont' css class to be validated
 */
$.validator.addMethod('gift-cert-amount', function (value, el) {
	var isOptional = this.optional(el);
	var isValid = (!isNaN(value)) && (parseFloat(value) >= 5) && (parseFloat(value) <= 5000);
	return isOptional || isValid;
}, Resources.GIFT_CERT_AMOUNT_INVALID);

/**
 * Add positive number validation method to jQuery validation plugin.
 * Text fields must have 'positivenumber' css class to be validated as positivenumber
 */
$.validator.addMethod('positivenumber', function (value) {
	if ($.trim(value).length === 0) { return true; }
	return (!isNaN(value) && Number(value) >= 0);
}, ''); // '' should be replaced with error message if needed

/**
 * Add password validation method to jQuery validation plugin.
 * Password field must have at least 1 number and be at least 8 characters long
 */
$.validator.addMethod('strongPassword', function(value) {
  return /^(?=.*\d).{8,}$/.test(value);
},'');

$.validator.addMethod('date-with-format', validateDateWithFormat, Resources.DATE_FORMAT_ERROR);

// handle form validation on event change or with direct trigger
function checkValidationStatus (event) {
	var $elem = $(event.target);
	var $form = $elem;
	var isFormValidation = true;
	if (event.target.nodeName !== 'FORM') {
		$form = $elem.parents('form');
		isFormValidation = false;
	}

	var validator = $form.validate({
		ignore: '.ignore'
	});
	if (isFormValidation && event.type === 'validate') {
		$form.valid();
		validator.resetForm();
	}

	// use alternative way to calculate empty fields if show 0 to double check it
	var invalidItems = validator.numberOfInvalids();
	var isValid = isFormValidation || ($elem.val() !== '' && $elem.valid());
	if (isValid && invalidItems < 2) {
		var emptyItems = $form.find(':input.required').filter(function () {
			return this.value === '';
		});
		if (emptyItems.length !== invalidItems) {
			invalidItems = emptyItems.length;
		}
	}

	// form.valid is primary flag, but we shouldn't trigger it unless there just single item left invalid
	isValid = isValid && (invalidItems < 1 && $form.valid());
	// reset error validation during typing
	if (event.type === 'keyup') {
		$elem.removeClass('error').closest('.form-row').find('.error-msg').css('display', 'none');
	}

	$form.find('[type="submit"]').prop('disabled', isValid);
	$form.find('[type="submit"]').attr('disabled', 'disabled');
	if (isValid) {
		$form.find('[type="submit"]').removeAttr('disabled');
	}

	window.console.debug($form.attr('id') || $form.attr('action'), isValid, invalidItems, event.type);
	return isValid;
}

function initFormPopulateValidation (i, form) {
	var $form = $(form);

	var $allInputs = $form.find(':input');
	var $requiredInputs = $allInputs.filter('.required');

	// start listening
	$form.on('validate', checkValidationStatus);
	$requiredInputs.on('change validate', _.debounce(checkValidationStatus, 200));
	var inputFields = $requiredInputs.filter('input, textarea');

	// that validation trigger should be supressed for now
	// as we handle timeout based checks, wait-for-input isn't seems like required at all
	inputFields.on('keyup', _.debounce(checkValidationStatus, 200));

	$form.trigger('validate');

	$form.on('submit', function (e) {
		$(this).find('.full-address').show();
		if ($form.valid()) {
			$(this).find('.full-address:not(.active)').hide();
			return true;
		}
		e.preventDefault();
	});
}

var validator = {
	regex: regex,
	settings: settings,
	init: function () {
		$('form:not(.suppress)').each(function () {
			$(this).validate();
		});

		$('form.pre-validate').each(initFormPopulateValidation);
	},

	initForm: function (f) {
		$(f).validate();
	},

	initFormPopulateValidation: initFormPopulateValidation
};

module.exports = validator;
